import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WorkingNotificationComponent } from "./working-notification.component";
import { OverlayModule } from "@angular/cdk/overlay";
import { OverlayWorkingDirective } from "./overlay-working.directive";

@NgModule({
  declarations: [WorkingNotificationComponent, OverlayWorkingDirective],
  imports: [CommonModule, OverlayModule],
  exports: [OverlayWorkingDirective],
  entryComponents: [WorkingNotificationComponent],
})
export class WorkingNotificationModule {}
